import { render, staticRenderFns } from "./Darkmode.vue?vue&type=template&id=6d0e08dc&scoped=true&"
var script = {}
import style0 from "./Darkmode.vue?vue&type=style&index=0&id=6d0e08dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0e08dc",
  null
  
)

export default component.exports